export const QUOTE = 'Quote';
export const INVOICE = 'Invoice';
export const INVOICE_REMINDER = 'Invoice Reminder';
export const PIPELINE_AUTOMATION = 'Pipeline Automation';
export const DEAL = 'Deal';
export const APPOINTMENT = 'Appointment';
export const CONTACT_RECORD = 'Contact Record';
